import { render, staticRenderFns } from "./VideoAvailabilityMessage.vue?vue&type=template&id=1a98bdae&scoped=true"
import script from "./VideoAvailabilityMessage.vue?vue&type=script&lang=js"
export * from "./VideoAvailabilityMessage.vue?vue&type=script&lang=js"
import style0 from "./VideoAvailabilityMessage.vue?vue&type=style&index=0&id=1a98bdae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98bdae",
  null
  
)

export default component.exports